<template>
  <div class="list-panel">
    <div v-loading="submitLoading" 
         element-loading-text="提交中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(255, 255, 255, 0.7)">
      <!-- 基础信息 -->
      <div class="main-container card-group-top">
        <div class="tab-con">
          <el-menu 
            :default-active="'default'" 
            class="el-menu-demo" 
            mode="horizontal">
            <el-menu-item index="default">账号信息</el-menu-item>
          </el-menu>
        </div>
        <div class="content-wrap">
          <form-basic ref="basicFormCon" :media-type="mediaType" :operate-type="'edit'" :init-value="mediaInfo"></form-basic>
        </div>
      </div>
      <!-- 价格信息 -->
      <!--
      <el-card class="box-card form-card">
        <form-price ref="priceFormCon" :price-list="mediaInfo && mediaInfo.mediaPriceList || []" :media-type="this.mediaType"></form-price>
      </el-card>
      -->
      <!-- 商务信息 -->
      <el-card class="box-card form-card">
        <form-business ref="busiFormCon" :business-list="mediaInfo && mediaInfo.mediaBusinessInfoList" :media-type="this.mediaType"></form-business>
      </el-card>
      <!-- 提交 -->
      <div class="submit-wrap">
        <el-button type="primary" @click="validForm" :disabled="submitLoading">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mediaConfig } from "@/const/config/media";
import formBasic from "./form-basic";
import formPrice from "./form-price";
import formBusiness from "./form-business";
import formFields from "@/const/media/formFields";
import util from "@/util/util"
import { updateMedia, getMediaInfo } from "@/api/media/index";
export default {
  components: {
    formBasic,
    //formPrice,
    formBusiness
  },
  created() {
    let mt_en = this.$route.path.split('/')[2];
    this.mediaType = this.MEDIA_TYPE[mt_en.toUpperCase()] || 1;
    this.mediaId = this.$route.query.mid ? parseInt(this.$route.query.mid) : null;
    this.getMediaInfo(this.mediaType, this.mediaId);
  },
  data () {
    return {
      mediaConfig: mediaConfig,
      mediaType: null,
      mediaId: null,
      submitLoading: false,
      mediaInfo: null
    }
  },
  methods: {
    /**
     * 获取账号详情
     * @param mediaType 资源类别
     * @param mediaId 资源id
     */
    getMediaInfo(mediaType, mediaId) {
      getMediaInfo(mediaType, { mediaId, mediaType })
        .then(res => {
          let data = res.data || {};
          this.mediaInfo = util.deepClone(data);
        })
        .catch(err => {
          this.mediaInfo = {}
        })
    },
    // 校验表单
    validForm() {
      let r = true;
      let that = this;
      // 基础信息
      const p1 = new Promise((resolve, reject) => {
        that.$refs.basicFormCon.$refs['basicForm'].validate((valid, obj) => {
          if (valid) resolve()
          else reject({type: 1, errors: Object.keys(obj)})
        })
      })
      // 价格信息
      // const p2 = new Promise((resolve, reject) => {
      //   that.$refs.priceFormCon.$refs['priceForm'].validate((valid, obj) => {
      //     if (valid) resolve()
      //     else reject({type: 1, errors: ["price"]})
      //   })
      // })
      // 商务信息
      const p3 = new Promise((resolve, reject) => {
        that.$refs.busiFormCon.$refs['bussinessForm'].validate((valid, obj) => {
          if (valid) resolve()
          else reject({type: 1, errors: ["business"]})
        })
      })

      Promise.all([p1, p3]).then(() => {
        this.$nextTick(() => {
          let basic = that.$refs.basicFormCon.$refs['basicForm'].model;
          // let priceList = that.$refs.priceFormCon.$refs['priceForm'].model.mediaPriceList;
          let businessList = that.$refs.busiFormCon.$refs['bussinessForm'].model.mediaBusinessInfos;

          let obj = util.deepClone(basic);
          // obj.mediaPriceList = priceList;
          obj.mediaBusinessInfos = businessList;
          if (obj.areaId instanceof Array) {
            obj.areaId = obj.areaId.join(',');
          }
          if (obj.areaId == 'NaN') {
            obj.areaId = '';
          }

          console.log('submitObj', obj)
          this.submitForm(obj)

        })
      }).catch(error => {
        let errorChs = error.errors.map(v => '“' + (formFields.list[v] || '') + '"')
        if (error.type === 2) {
          this.$message.error(`表单不完整！`);
        } else {
          this.$message.error(`表单不完整！请检查${errorChs}等字段是否正确填写`);
        }
      });
    },
    /**
     * 编辑
     * @param form 编辑表单
     */
    submitForm(form) {
      this.submitLoading = true;
      updateMedia(this.mediaType, form)
        .then(res => {
          let mtt_ch = mediaConfig.getAppointed("media_ch", this.mediaType);
          let mtt_en = mediaConfig.getAppointed("media_en", this.mediaType);
          this.$message.success(`账号信息提交成功!`);
          this.submitLoading = false;
          setTimeout(() => {
            this.$router.push({ path: `/media/${mtt_en}` });
          }, 500)
        })
        .catch(err => {
          this.submitLoading = false;
        })
    }
  },
}
</script>

<style lang="scss" scoped>
.media_type-list {
  display: flex;
  align-items: center;
  .label {
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
  }
}
.form-card {
  margin-bottom: 10px;
}
.submit-wrap {
  text-align: center;
  margin-top: 20px;
}

.card-group-top {
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-wrap {
    padding: 20px;
  }
}
</style>